export const adminMenu = {
  dashboard: { name: '대시보드', link: '/admin/dashboard' },
  users: { name: '유저 관리', link: '/admin/users' },
  payments: { name: '결제 내역', link: '/admin/payments' },
  estate: { name: '단지 관리', link: '/admin/estate' },
  peakPrices: { name: '전고점 수동 설정', link: '/admin/peak-prices' },
  realPrice: { name: '실거래가 업로드', link: '/admin/real-price' },
  schedule: { name: '크롤링 주기 설정', link: '/admin/schedule' },
  emailLogs: { name: '이메일 발송 내역', link: '/admin/email-logs' },
  alertSnapshots: { name: '급매 알림 내역', link: '/admin/alert-snapshots' },
};

export const adminMenuList = Object.values(adminMenu);
